import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const StandardLoader = () => (
  <div className='d-flex flex-fill flex-column align-items-center justify-content-center h-100 w-100  p-3'>
    <LoadingSpinner desc='' />
  </div>
);

export default StandardLoader;
